/** Valores monetários da NFC-e têm 2 casas (layout da NF-e/NFC-e). */
export function roundMoney(value: number): number {
  return Math.round((value + Number.EPSILON) * 100) / 100;
}

/**
 * Tempo restante para cancelar a NFC-e, em segundos, a partir do limite
 * calculado pelo nf-server (`limiteCancelamento`). null = sem limite conhecido.
 */
export function segundosParaCancelar(
  limiteCancelamento: string | null | undefined,
  agora: Date = new Date()
): number | null {
  if (!limiteCancelamento) return null;

  const limite = new Date(limiteCancelamento).getTime();
  if (Number.isNaN(limite)) return null;

  return Math.max(Math.floor((limite - agora.getTime()) / 1000), 0);
}

export function formatarTempoRestante(segundos: number | null): string {
  if (segundos === null) return "";
  if (segundos <= 0) return "prazo encerrado";

  const minutos = Math.floor(segundos / 60);
  const resto = segundos % 60;

  if (minutos === 0) return `${resto}s`;
  return `${minutos}min ${resto.toString().padStart(2, "0")}s`;
}
